import { Navigate, Route } from "react-router-dom";

import { featureFlagRoute } from "@/shared/routing/featureFlagRoute";

import { Device } from "./Device";
import { DeviceDatasets } from "./DeviceDatasets";
import { DeviceDetails } from "./DeviceDetails";
import { DeviceFiles } from "./DeviceFiles";
import { Devices } from "./Devices";
import { DeviceSessions } from "./DeviceSessions";
import { DeviceTokens } from "./DeviceTokens";

export const DevicesRoutes = () => [
  <Route key={"/"} index element={<Devices />} />,
  <Route key={"id"} path=":deviceId" element={<Device />}>
    {/* Bare `/devices/:deviceId` has no tab to render; redirect to the default. */}
    <Route index element={<Navigate to="datasets" replace />} />
    <Route path="datasets" element={<DeviceDatasets />} />
    <Route path="files" element={<DeviceFiles />} />
    {featureFlagRoute({
      path: "sessions",
      flagName: "release-sessions",
      redirectTo: ({ params }) => `/devices/${params.deviceId}/datasets`,
      element: <DeviceSessions />,
    })}
    <Route path="details" element={<DeviceDetails />} />
    <Route path="tokens" element={<DeviceTokens />} />
    {/* Unknown subpath (typo, removed tab, stale bookmark): redirect to the default. */}
    <Route path="*" element={<Navigate to="datasets" replace />} />
  </Route>,
];
